module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAKCAYAAACE2W/HAAAAAXNSR0IArs4c6QAAAIhJREFUKBV9i8ERgCAMBOHFlwYogSIswzpogzoowyIswQb8+hIvDgwYgswcuVz2lJq8nPNKmpzlGAUHnUVOplgKWEMbVB95zbBxBRRqo5thJLsEoIeurlAtZb5Dm8XBQHslhUk30xrFIYwCzKP4KeK6QDenhJ2Y5S3DWOgQoFlErFX40oz4ydMDa0BGyKJITrsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/arrow_up.png
// module id = 1455
// module chunks = 1